<template>
  <div>
    <v-container class="pt-10">
      <v-row>
        <v-col cols="8" offset="2" color="white" class="text-center">
          <BaseParagraph>
              Vous devez confirmer votre compte
              pour pouvoir accéder à l'extranet EXCOSUP.
              <br><br>
              Pour confirmer votre compte, veuillez cliquer sur le lien qui vous
              a été envoyé par email.
          </BaseParagraph>
          <BaseButton
            color="primary"
            @click="resendConfirmationEmail">
            Renvoyez-moi un email
          </BaseButton>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import BaseParagraph from '@/components/BaseParagraph.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'PendingAccount',
  components: { BaseButton, BaseParagraph },
  computed: mapState('authentication', ['form']),
  methods: {
    ...mapActions('authentication', ['resendConfirmationLink']),
    ...mapMutations(['setAlert']),
    resendConfirmationEmail() {
      this.resendConfirmationLink().then(() => {
        this.setAlert({
          text: 'Merci. Un email contenant un lien pour confirmer votre compte va vous être envoyé.',
          color: 'success',
          show: true,
        });
      });
    },
  },
  mounted() {
    if (!this.form.email) {
      this.$router.push('/connexion');
    }
  },
};
</script>
